export enum ReferralStatus {
  DRAFT = 'DRAFT',
  SIGNED = 'SIGNED',
  DELETED = 'DELETED',
  DEFAULT = DRAFT,
}
